var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"href":_vm.href,"target":"_blank","rounded":""}},[_c('v-icon',{class:_vm.cssClass,attrs:{"left":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }